import { constants } from 'lib_ui-services';
import { BbState } from 'lib_ui-primitives';
import { differenceInMinutes } from 'date-fns';

export default {
    verb: 'didNew',
    namespace: 'item',
    relation: 'transaction',
    description: 'New a record from a previously existing record of the same namespace/relation.',
    useCaseIds: [constants.useCaseIds.FREIGHT_RUNNER, constants.useCaseIds.RB_DIRECTSCAN],
    //this is the actual logic:
    logic: didNew
};

// new is a reserved word
async function didNew({ data, context }) {
    const retention = {
        id: context.session.profile.userId,
        scope: constants.retention.SCOPE.LOCAL,
        visibility: constants.retention.VISIBILITY.PER_BROWSER,
        duration: constants.retention.DURATION.USER_SESSION
    };

    // lookup the count for the current user...
    const bbState = BbState.connect(retention);
    const totalScans = await bbState.getAsync('palletCounter', 0);
    data.record.totalScans = totalScans.toString();
    //if they haven't done enough to calculate an average yet, avoid division by zero, just return 0s.
    if (!totalScans || totalScans <= 1) {
        data.record.minutesPerPallet = '0';
        data.record.palletsPerMinute = '0';
        return data;
    }

    const timeOfFirstScan = await bbState.getAsync('firstScan', new Date());
    const minutesSinceFirstScan = differenceInMinutes(new Date(), new Date(timeOfFirstScan)) || 1;
    // calculate the average, round to 2 decimals
    data.record.minutesPerPallet = (Math.round((minutesSinceFirstScan / totalScans) * 100) / 100).toString();
    data.record.palletsPerMinute = (Math.round((totalScans / minutesSinceFirstScan) * 100) / 100).toString();
    return data;
}
